module.exports = __webpack_public_path__ + "static/img/zhangxinyuan.8d336d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/zhangxinyuan.jpg
// module id = RESa
// module chunks = 0